// TODO: These are not final, a new cart controller might need to be
// written which is more json/ajax friendly
export default {
  addCartItem({ product_id, term, options }) {
    // eslint-disable-next-line no-undef
    return axios.post('/plan-builder/add-products', [
      {
        product_name: product_id,
        term: term,
        options: options,
        referrer: window.location.href,
        with_addon_suggestions: true
      }
    ]);
  },

  getCartItems() {
    // eslint-disable-next-line no-undef
    return axios.post('/plan-builder/get-products', {
      with_addon_suggestions: true
    });
  },

  removeCartItem(cart_item_id) {
    // eslint-disable-next-line no-undef
    return axios.post('/plan-builder/remove-product', {
      item_id: cart_item_id,
      with_addon_suggestions: true
    });
  },

  updateCartItem(cart_item_id, { product_id, term, quantity, domain, billing_plan_id, term_type }) {
    // eslint-disable-next-line no-undef
    return axios.post('/plan-builder/update', {
      item_id: cart_item_id,
      product_id: product_id,
      term: term,
      options: {
        quantity: quantity,
        domain: domain,
        billing_plan_id: billing_plan_id,
        term_type: term_type
      },
      with_addon_suggestions: true
    });
  },

  updateCartGlobalTerm(term, { item_ids }) {
    // eslint-disable-next-line no-undef
    return axios.post('/plan-builder/update-global-term', {
      term: term,
      item_ids: item_ids,
      with_addon_suggestions: true
    });
  },

  addDiscount(discount_code) {
    // eslint-disable-next-line no-undef
    return axios.post('/cart/checkout/discount', {
      discount: discount_code,
      with_addon_suggestions: true
    });
  }
};
